import { FC } from 'react';
import { PREVIEW_ANIMATION, PREVIEW_SKELETON_CHIP_COUNT } from './constants';
import * as S from './styles';

export const PreviewLoadingSkeleton: FC = () => (
  <>
    <S.ExpandRow $delayMs={PREVIEW_ANIMATION.titleDelayMs}>
      <S.ExpandRowInner>
        <S.TitleSkeleton aria-hidden data-testid="wordlist-preview-title-skeleton" />
      </S.ExpandRowInner>
    </S.ExpandRow>
    <S.WordListSkeleton data-testid="wordlist-locals-preview-skeleton">
      {Array.from({ length: PREVIEW_SKELETON_CHIP_COUNT }, (_, index) => (
        <S.ExpandRow
          key={index}
          $delayMs={
            PREVIEW_ANIMATION.titleDelayMs +
            PREVIEW_ANIMATION.rowExpandMs +
            index * PREVIEW_ANIMATION.chipStaggerMs
          }
        >
          <S.ExpandRowInner>
            <S.WordSkeleton aria-hidden data-testid="wordlist-preview-word-skeleton" />
          </S.ExpandRowInner>
        </S.ExpandRow>
      ))}
    </S.WordListSkeleton>
  </>
);

export const PreviewMediaSkeleton: FC = () => (
  <S.MediaSkeletonWrap>
    <S.MediaSkeleton aria-hidden data-testid="wordlist-preview-media-skeleton" />
  </S.MediaSkeletonWrap>
);
